<template>
    <div class="wait-screen" style="position: relative">
        <div @click="enterTAA()" style="overflow: hidden;">
            <template v-if="video">
                <video autoplay loop muted :src="image || splash"></video>
            </template>
            <template v-else>
                <img class="splash" :src="image">
            </template>
            <div v-if="allowAcessibilidade()" class="accessibility" @click="accessibilityEnter">
                <span>{{ getString('modo_acessibilidade') }}</span>
                <img :src="accessibility">
            </div>
        </div>
        <div class="flags_container" v-if="flasgsEnabled">
            <img class="country_flag" :src="flags.pbr" v-if="portugueseEnabled()" @click="chooseLang('pt-br')">
            <img class="country_flag" :src="flags.eng" v-if="englishEnabled()" @click="chooseLang('en')">
            <img class="country_flag" :src="flags.esp" v-if="spanishEnabled()" @click="chooseLang('es')">
        </div>
        <div class="keypass" v-if="!configButton">
            <div class="k1" @click="keypass('k1')"></div>
            <div class="k2" @click="keypass('k2')"></div>
            <div class="k3" @click="keypass('k3')"></div>
        </div>
        <div class="config-button" @click="enterLogin()" v-else></div>
        <div class="overlay" v-if="showIdentificationModal"></div>
        <transition name="bounce">
            <IdentificationModal v-if="showIdentificationModal" @navigateToHome="navigateToHome"></IdentificationModal>
        </transition>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
import IdentificationModal from '../components/IdentificationModal.vue'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
import LocaleController from '@/assets/controllers/LocaleController'
import requestModule from '@/assets/libs/requestModule'
import eventModule from '@/assets/libs/eventModule'
import moment from 'moment'
import CashbackCampaingController from '../assets/controllers/CashbackCampaingController'
import PromotionalCampaignsController from '@/assets/controllers/PromotionalCampaignsController'
import SaleController from '@/assets/controllers/SaleController'
import UpdaterController from '../assets/controllers/UpdaterController'
import CartController from '../assets/controllers/CartController'
import ClarityController from '@/assets/controllers/ClarityController'

export default {
    name: 'WaitScreen',
    data () {
        return {
            configButton: false,
            keys: {
                k1: this.k1,
                k2: this.k2,
                k3: this.k3
            },
            keysPressed: [],
            accessibility: require('../../static/icons/accessibility.png'),
            splash: this.getSplashImg(),
            flags: {
                pbr: require('../../static/icons/brazil_flag.png'),
                eng: require('../../static/icons/eua_flag.png'),
                esp: require('../../static/icons/spain_flag.png')
            },
            flagClicked: false,
            showIdentificationModal: false,
            image: null,
            video: false,
            flasgsEnabled: true,
            cashbackCampaignStatus: null
        }
    },
    components: {
        IdentificationModal
    },
    created () {
        eventModule.$on('closeIdentificationModal', this.closeIdentificationModal)
    },
    beforeDestroy () {
        eventModule.$off('closeIdentificationModal', this.closeIdentificationModal)
    },
    mounted () {
        let self = this
        Util.setLocalVar('lang', '')
        this.updateTaaImages()
        Util.removeAccessibilityClass()
        LocaleController.resetToMainLanguage()
        if (!Util.isOracle()) {
            requestModule.postRequest('getBaseConfig', { type: 'basic' }).then(confData => {
                self.configButton = typeof (confData.configButton) === 'boolean' ? confData.configButton : false
            })
        }
        SaleController.setPreOrderDate('')
        CartController.clearCartData()
        if (Util.isGertecSk210()) {
            window.GertecBarcodeReader.stopDecode()
        }
        CashbackCampaingController.getStatus().then(status => {
            this.cashbackCampaignStatus = status
        })
        this.getImage()
        ClarityController.stopSession()
    },
    methods: {
        getSplashImg: function () {
            return require('../../static/icons/splash.jpeg')
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        chooseLang: function (lang) {
            this.flagClicked = true
            eventModule.$emit('languageChosen', lang)
            let langs = {
                en: 'English',
                es: 'Spanish',
                'pt-br': 'Portugues Brasil'
            }
            LocaleController.setCurrentLanguage(lang)
            Util.showSuccessNotification({ title: `${langs[lang]}` })
        },
        portugueseEnabled: function () {
            return LocaleController.langPortugueseEnabled()
        },
        englishEnabled: function () {
            return LocaleController.langEnglishEnabled()
        },
        spanishEnabled: function () {
            return LocaleController.langSpanishEnabled()
        },
        allowAcessibilidade: function () {
            return Util.allowAcessibilidade()
        },
        k1: function () {
            this.keysPressed = []
            this.keysPressed.push(2)
        },
        k2: function () {
            this.keysPressed.push(1)
            if (this.keysPressed.length === 4) {
                let sum = this.keysPressed.reduce((partialSum, a) => partialSum + a, 0)
                if (sum === 3) {
                    this.$router.push({
                        name: 'Login',
                        params: { 'allowed': true }
                    })
                }
            }
        },
        k3: function () {
            this.keysPressed.push(-1)
        },
        keypass: function (k) {
            this.keys[k]()
        },
        accessibilityEnter: function () {
            Util.setAccessibilityClass()
            if (Util.askPhoneNumber()) {
                this.showIdentificationModal = true
                this.flasgsEnabled = false
                eventModule.$emit('setIdentificationModalStatus', true)
            } else {
                this.navigateToHome()
            }
        },
        enterTAA: function () {
            let isBlockedForThisDate = Util.getLocalVar('blockedForDate') === moment().format('DD-MM-YYYY')
            CashbackCampaingController.clearData()
            let preOrderDate = moment().format('DD-MM-YYYY HH:mm:ss')
            SaleController.setPreOrderDate(preOrderDate)
            if (isBlockedForThisDate) {
                Util.showInfoModal(LocaleController.getString('caixa_bloqueado'))
            } else {
                ClarityController.startSession()
                ClarityController.setUserUniqueId()
                if (Util.askPhoneNumber()) {
                    this.showIdentificationModal = true
                    this.flasgsEnabled = false
                    eventModule.$emit('setIdentificationModalStatus', true)
                } else {
                    this.navigateToHome()
                }
            }
        },
        navigateToHome: async function () {
            if (this.showIdentificationModal) {
                this.showIdentificationModal = false
                await this.delay(100)
            }
            eventModule.$emit('setIdentificationModalStatus', false)
            if (this.flagClicked) {
                this.flagClicked = false
            }

            IdentifiedConsumerController.clearConsumerData()
            IdentifiedConsumerController.clearCompPaymentData()
            DifferentiatedPricesController.clearDiffPrices()

            PromotionalCampaignsController.fetchPromotionalCampaigns()

            if (Util.getLocalConfigs('enableLoginInicio')) {
                this.$router.push({
                    name: 'Identification'
                })
                return
            }

            if (Util.isBalancaMode()) {
                this.$router.push({
                    name: 'BalancaScreen'
                })
            } else {
                this.$router.push({
                    name: 'Home',
                    params: { 'showModeEntrega': true }
                })
            }
        },
        getImage: async function () {
            await UpdaterController.updateStoredImages()
            this.image = Util.getConfigImage('espera') || this.splash
            this.video = this.isVideo(this.image)
            this.$forceUpdate()
        },
        enterLogin: function () {
            this.$router.push({
                name: 'Login',
                params: { 'allowed': true }
            })
        },
        isVideo: function (fileName) {
            let videos = ['mp4', 'mkv', 'webm']
            if (!fileName) {
                return false
            }
            let ext = fileName.split('/')[1].split(';').shift()
            if (ext && videos.includes(ext)) {
                return true
            }
            return false
        },
        delay: function (time) {
            return new Promise(function (resolve) {
                setTimeout(resolve, time)
            })
        },
        closeIdentificationModal: function () {
            CashbackCampaingController.clearData()
            this.showIdentificationModal = false
        },
        updateTaaImages: async function () {
            await UpdaterController.updateStoredImages()
            this.$forceUpdate()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.wait-screen {
    img.splash {
        height: 100vh;
        width: 100vw;
        object-fit: fill;
        margin: auto;
        margin: 0;
        padding: 0;
        border: none;
        pointer-events: none;
    }

    video {
        height: 100vh;
        width: 100vw;
        object-fit: contain;
        margin: auto;
        margin: 0;
        padding: 0;
        border: none;
        pointer-events: none;
    }

    .flags_container {
        position: absolute;
        right: 30px;
        bottom: 4rem;
        display: flex;
    }

    .country_flag {
        display: block;
        height: 6rem;
        max-width: 6rem;
        z-index: 1000;
    }

    .keypass {
        position: absolute;
        display: block;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        pointer-events: none;

        div {
            display: block;
            width: 320px;
            height: 320px;
            margin-bottom: 15px;
            z-index: 100;
            position: absolute;
            pointer-events: auto;

            &.k1 {
                background: none;
                bottom: 0;
                left: 0;
            }

            &.k2 {
                top: 0;
                background: none;
            }

            &.k3 {
                background: none;
                top: 0;
                right: 0;
            }
        }
    }

    .config-button {
        position: absolute;
        top: 0;
        right: 0;
        opacity: 0;
        height: 200px;
        width: 200px;
    }

    .overlay {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 2;
    }

    .accessibility {
        position: fixed;
        z-index: 1;
        width: 635px;
        height: 130px;
        bottom: 325px;
        right: 50px;
        border-radius: 70px;
        -o-object-fit: contain;
        object-fit: contain;
        background: white;
        display: grid;
        grid-template-columns: 80% 15%;

        span {
            font-weight: bold;
            text-align: center;
            font-size: 2.8rem;
            padding-left: 15px;
            margin: auto;
        }

        img {
            display: block;
            width: 100px;
            height: 100px;
            margin: auto;
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .wait-screen {
        .keypass {
            div {
                width: 80px;
                height: 80px;
                margin-bottom: 0;

                &.k1 {
                    bottom: 30px;
                }
            }
        }

        .flags_container {
            right: 10px;
            bottom: 40px;
        }

        .country_flag {
            height: 50px;
            max-width: 50px;
        }
        .accessibility {
            display: none;
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    iframe {
        margin-top: -60px;
        width: 100vw;
    }

    .flags_container {
        bottom: 60px;
    }

    .accessibility {
        height: 90px !important;
        bottom: 220px !important;
        width: 430px !important;
        right: 35px !important;

        span {
            font-size: 1.5rem !important;
            text-transform: uppercase !important;
        }

        img {
            margin-top: 10px !important;
            width: 70px !important;
            height: 70px !important;
            margin-left: -10px !important;
        }
    }
}

.bounce-enter-active {
    animation: bounce-in 0.4s;
}

.bounce-leave-active {
    animation: bounce-in 0.3s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

.overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 0;
}

@media (orientation: landscape) {
    .wait-screen {
        .flags_container {
            bottom: 40px;

            img {
                max-width: 5rem;
                height: 5rem;
            }
        }
        .accessibility {
            display: none;
        }

        .keypass {
            div {
                display: block;
                width: 220px;
                height: 220px;
                margin-bottom: 0;
                z-index: 100;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/WaitScreen.vue